"use client";

import { expenseAndService } from "@/utils/objects";
import React, { FC, useEffect } from "react";
import CommonEdit from "@/components/common/Edit";
import { mergeDateAndTime, seperateDateAndTime } from "@/utils/formChange";
import IncomingForm from "../forms/IncomingForm";
import axiosInstance from "@/utils/axiosInstance";
import { singleProp } from "@/interface/dataInterface";
import { IncomeData } from "@/interface/entityInterface";

const IncomingsEdit: FC<singleProp> = ({ prop }) => {
  const [formProp, setFormProp] = React.useState({
    ...expenseAndService,
    value: "",
    incomings_type_id: 0,
  });

  useEffect(() => {
    if (!prop) return;
    const getIncome = async () => {
      const { data } = await axiosInstance.get<IncomeData>(`/incomings/${prop}`);
      const { odometer, notes, date, vehicle_id, value, incomings_type_id } =
        data;
      setFormProp({
        odometer: odometer || 0,
        notes: notes || "",
        time: seperateDateAndTime(date).timePart || "",
        vehicle_id: vehicle_id || 0,
        date: seperateDateAndTime(date).datePart || date,
        value,
        incomings_type_id,
      });
    };

    getIncome();
  }, [prop]);

  return (
    <CommonEdit
      id={prop}
      title="Edit"
      resource="incomings"
      data={{
        ...formProp,
        date: mergeDateAndTime(formProp.date, formProp.time),
        incomings_type_id: +formProp.incomings_type_id,
        vehicle_id: +formProp.vehicle_id,
        value: +formProp.value,
      }}
    >
      <IncomingForm formProp={formProp} setFormProp={setFormProp} />
    </CommonEdit>
  );
};

export default IncomingsEdit;
